/* eslint-disable import/prefer-default-export */
/* eslint-disable no-unused-vars */

import {
    LAST_APPROVED_WITHDRAW,
    WITHDRAW_BALANCE,
    WITHDRAW_LIST,
    HANDLE_INPUT,
    RESET_FORM_INPUT,
    SET_RESPONSE_STATUS,
    LOADER,
    TINY_LOADER,
    RESET_RESPONSE_STATUS,
    SHOW_ALERT,
} from './Types';

const initialWithdrawState = {
    withdrawList: [],
    withdrawBalance: {},
    withdrawStatus: [
        {
            value: 'pending',
            title: 'Pending',
        },
        {
            value: 'approved',
            title: 'Approved',
        },

        {
            value: 'cancelled',
            title: 'Cancelled',
        },
    ],
    lastApproved: [],
    withdrawRequest: {
        amount: '',
        method: '',
    },
    resetWithdrawRequest: {
        amount: '',
        method: '',
    },
    responseMessage: {},
    loader: false,
    tiny_loader: false,
    showAlert: false,
};
const withdrawReducer = (state = initialWithdrawState, { type, payload }) => {
    switch (type) {
        case WITHDRAW_LIST:
            return { ...state, withdrawList: payload };
        case WITHDRAW_BALANCE:
            return {
                ...state,
                withdrawBalance: payload.balance,
                lastApproved: payload.lastApproved,
            };
        case HANDLE_INPUT:
            return {
                ...state,
                withdrawRequest: {
                    ...state.withdrawRequest,
                    [payload.name]: payload.value,
                },
            };
        case RESET_FORM_INPUT:
            return {
                ...state,
                withdrawRequest: payload,
            };
        case SET_RESPONSE_STATUS:
            console.log('payload', payload);
            return {
                ...state,
                responseMessage: { ...payload },
            };
        case RESET_RESPONSE_STATUS:
            return {
                ...state,
                responseMessage: payload,
            };
        case LOADER:
            return {
                ...state,
                loader: payload,
            };
        case TINY_LOADER:
            return {
                ...state,
                tiny_loader: payload,
            };
        case SHOW_ALERT:
            return {
                ...state,
                showAlert: payload,
            };
        default:
            return state;
    }
};
export default withdrawReducer;
